import { FC, useEffect } from 'react';
import { useIsUserReadOnlyRole } from '../../members/api/user-roles-api';
import { IssueDetails } from '../../issues/common/types/issues-types';
import QuickFixModal from '../components/QuickFixModal';
import { AggregationItem, Nullable } from 'common-types';
import CreatePRFormContainer from './CreatePRFormContainer';
import { useSnapshot } from 'valtio';
import QuickFixStore from '../stores/quick-fix-store';
import { Box, Typography } from '@mui/material';
import SkeletonLoader from '../../executive-summary/components/SkeletonLoader';
import { cancelPolling, getFix } from '../actions/quick-fix-actions';
import { clearStore } from '../store-actions/quick-fix-store-actions';

const QuickFixModalContainer: FC<
  React.PropsWithChildren<QuickFixModalContainerProps>
> = props => {
  const { loadingError, isLoadingFileFixes } = useSnapshot(QuickFixStore);
  const { open, onClose, selectedIssue, selectedAggs, onViewCodeFix } = props;

  const modalHeader = 'Open Pull Request';

  const isReadOnlyRole = useIsUserReadOnlyRole();
  useEffect(() => {
    open && selectedIssue && getFix(selectedIssue, selectedAggs);
  }, [open, selectedAggs, selectedIssue]);

  useEffect(
    () => () => {
      cancelPolling();
      clearStore();
    },
    [],
  );

  return (
    <QuickFixModal open={open} onClose={onClose} modalHeader={modalHeader}>
      <Box
        display='flex'
        flexDirection='column'
        justifyContent='space-between'
        height={300}>
        {loadingError ? (
          <Box
            height='100%'
            flexGrow={1}
            width='100%'
            display='flex'
            alignItems='center'
            justifyContent='center'>
            <Typography variant='h6' color='text.primary'>
              Failed to load Merge Request info
            </Typography>
          </Box>
        ) : (
          <SkeletonLoader
            loading={isLoadingFileFixes}
            message='Loading Merge Request Info'>
            <CreatePRFormContainer
              onClose={onClose}
              selectedAggs={selectedAggs}
              selectedIssue={selectedIssue}
              isReadOnlyRole={isReadOnlyRole}
              onViewCodeFix={onViewCodeFix}
            />
          </SkeletonLoader>
        )}
      </Box>
    </QuickFixModal>
  );
};

export interface QuickFixModalContainerProps {
  selectedIssue: Nullable<IssueDetails>;
  selectedAggs: AggregationItem[];
  open: boolean;
  onClose: () => void;
  onViewCodeFix?: () => void;
}

export default QuickFixModalContainer;
